
    import './styles.scoped.css';
    export default {
  "tabs-header-list": "awsui_tabs-header-list_1acwa_dp0cl_5",
  "active-tab-header": "awsui_active-tab-header_1acwa_dp0cl_6",
  "tab-label": "awsui_tab-label_1acwa_dp0cl_7",
  "tab-dismiss-button": "awsui_tab-dismiss-button_1acwa_dp0cl_8"
};
  